import { render, staticRenderFns } from "./ExtraFieldTab.vue?vue&type=template&id=1e5f4c92"
import script from "./ExtraFieldTab.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports